<template>
   <v-dialog
        v-model="addWithPDF"
        persistent
        max-width="300px"
        transition="dialog-top-transition"
      >
        <v-card>
          <v-card-title class="text-h6 text-center">
            Visualización de reportes
          </v-card-title>
          <v-container>
            <v-row style="padding: 10px">
              <v-col class="text-center">
                <v-btn
                  width="100%"
                  outlined
                  color="error"
                  @click="exportToPdf()"
                  :disabled="disableButton"
                >
                  Consulta dental
                  <v-icon right>mdi-file-pdf-box</v-icon>
                </v-btn>
              </v-col>
              <v-col class="text-center">
                <v-btn
                  width="100%"
                  outlined
                  color="error"
                  @click="exportPDFPrescription()"
                  :disabled="this.dentaltoPDF.idPrescription == null"
                >
                  Receta médica
                  <v-icon right> mdi-file-pdf-box </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions class="text-center">
            <v-col>
              <v-btn color="error" text @click="returnTable(false)">
                Salir <v-icon right>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
</template>

<script>
import { ReportPDFRequest } from "@/core/request"
import moment from "moment";
export default {
    props: {
        model: Object,
        addWithPDF: Boolean,
        dentaltoPDF: Object,
        productsListPrescription: Array,
    },
    data(){
      return{
        disableButton: false,
      }
    },
    methods:{
    returnTable() {
      let returnTable = true;
      this.$emit("returnTable", returnTable);
    },
    exportToPdf() { 
      if (this.model.idMedicalPractice) {
        const fileName = `Consulta_Dental_${
          this.model.idMedicalPractice
        }_${moment(new Date(this.model.startTime)).format("YYYY-MM-DD")}`;
        // console.log(fileName);   

        let data = {
          idConsultation: this.dentaltoPDF.idMedicalPractice,
          idDiagnostic: this.dentaltoPDF.idDiagnostic,
          fileName: fileName,
        };
        ReportPDFRequest.downloadDentalReport(data)
          .then((res) => {
            if (res.status == 200 && res.data.type != "application/json") {
              this.$utilFront.openPDF(res.data);
            } else {
              this.$utilFront.displayErrorPdf(res.data);
            }
          })
          .finally(() => {});
      }
    },
    // exportPDFPrescription() {
    //   if (this.$utilFront.nonEmptyList(this.productsListPrescription)) {
    //     console.log(this.productsListPrescription);
    //     let arrProducts = [];
    //     // for (const key in this.model.products) {
    //     //   let obj = {
    //     //     quantity: this.model.products[key].quantity,
    //     //     products: {
    //     //       idProduct: this.model.products[key].product.idProduct,
    //     //     },
    //     //     instructions: this.model.products[key].instructions,
    //     //   };
    //     //   arrProducts.push(obj);
    //     // }
    //     let url = new URL(location.origin);
    //     let data = {
    //       idPrescription: this.model.idPrescription,
    //       url: url,
    //       fileName: "Receta",
    //       // listPrescription: arrProducts,
    //       // idMedicalPractice: this.dataConsulty.idMedicalPractice,
    //        idHumanResource: this.$utilFront.getIdHumanResource(),
    //     };
    //     this.loader = true;
    //     ReportPDFRequest.downloadPrescription(data, this);
    //   }
    // },
    exportPDFPrescription() {
      let url = new URL(location.origin);
      let data = {
        idPrescription: this.dentaltoPDF.idPrescription,
        url: url,
        fileName: "Receta",
      };
      this.loader = true;
      ReportPDFRequest.downloadPrescription(data, this);
    },
    }

}
</script>
